export default "/images/f828a853d3235f01adcaa2ba64b31826.avif";